import React from 'react'
import TextInputField from '../../infra/components/formInput/CustomTextInput'

const ProductItems = (props) => {
    const { onChange, value } = props
    const [productIds, setProductIds] = React.useState(value.length ? value : [""])
    const handleChange = (index, value) => {
        const newValue = productIds.map((productId, idx) => {
            if (idx === index) {
                return value
            } else {
                return productId
            }
        })
        setProductIds(newValue)
        onChange(newValue)
    }
    const handleAddItem = () => {
        const newValue = productIds
        newValue.push("")
        setProductIds(newValue)
        onChange(newValue)
    }
    const handleRemoveItem = (index) => {
        const newValue = productIds.filter((_, i) => i !== index)
        setProductIds(newValue)
        onChange(newValue)
    }
    return (
        <div className="form-group">
            <span className="col-sm-2">Product Items</span>
            <div className="col-sm-10">
                {productIds.map((products, index) => (
                    <div key={index} className='row'>
                        <div className='col-sm-10'>
                            <TextInputField
                                className="form-control-text"
                                field={'productId'}
                                value={products}
                                onChange={(field, value) => handleChange(index, value)}
                                placeholder={"Product Retail Id"}
                            />
                        </div>
                        <div className='col-sm-2'>
                            {index !== 0 ? <a className='btn btn-danger' style={{ float: "right" }} onClick={() => handleRemoveItem(index)}>Remove Product Items</a> : <a className='btn btn-success' style={{ float: "right" }} onClick={() => handleAddItem()}>Add Product Items</a>}
                        </div>
                    </div>
                )
                )}
            </div>
        </div>
    )
}

export default ProductItems